import React from 'react';

import { Subdivision } from '../../types/subdivision';

type ProfileData = {
  login: string;
  role: string[];
  token: string;
};
type UserData = {
  email: string;
  role: string;
  id: string;
};

type IsLoggedIn = {
  loogedin: boolean;
  setLogin: (bool: boolean) => void;
  setUserData: ({ role, email }: UserData) => void;
  userData: UserData;
};
export const Context = React.createContext<Partial<IsLoggedIn>>({});
